import * as React from "react";
import { Tooltip, UncontrolledTooltip } from "reactstrap";

interface IProps {
    element: React.ReactElement,
    tooltip: any,
    params?: {[key: string]: any},
    uncontrolled?: boolean,
    wrapper?: {
        component: any,
        params?: {[key: string]: any},
    },
}

function TooltipComponent({ element, tooltip, params, uncontrolled, wrapper }: IProps) {
    
    const linkRef = React.useRef()
    const [ready, setReady] = React.useState(false)

    React.useEffect(() => {
        if (linkRef.current) {
            setReady(true)
        }
    }, [linkRef.current])
    
    
    const { children, ...elementProps } = element.props;
    const myElement = (
        <element.type
            ref={linkRef}
            {...elementProps}
        >
            {children}
        </element.type>
    )
    const MyTooltip = uncontrolled === true ? UncontrolledTooltip : Tooltip;
    
    return (
        <>
            
            {wrapper !== undefined && wrapper !== null ? (
                <wrapper.component
                    {...((wrapper.params !== undefined && wrapper.params !== null) ? wrapper.params : {})}
                >
                    {myElement}
                </wrapper.component>
            ) : myElement}
            
            {ready && (
                <MyTooltip
                    target={linkRef.current}
                    boundariesElement="window"
                    {...params}
                >
                    {tooltip}
                </MyTooltip>
            )}
        </>
    )
    
}

export default TooltipComponent;
